import * as React from 'react';
import { primaryFactory } from 'src/services/themeColors';

interface IStepProps {
  children: React.ReactNode;
  title: string;
  index: number;
  Icon: React.ReactElement;
}

const H2Primary = primaryFactory('h2');

const Step = ({ children, title, index, Icon }: IStepProps) => (
  <section className="step rounded bg-grey p-8 my-8 flex">
    <div className="flex relative pl-4 pt-4">
      <span className="block absolute z-10 pin-t pin-l bg-black text-center text-white text-lg w-12 h-12 pt-3 rounded-full">
        {index}
      </span>
      {Icon}
    </div>
    <div className="flex-1 py-4 pl-12 pr-24">
      <H2Primary className="font-normal text-lg mb-6">
        {index}. {title}
      </H2Primary>
      {children}
    </div>
  </section>
);

export default Step;



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulkExcel/components/Step.tsx